'use es6';

import { AdWordsKeywordTypes } from './Constants';
export const getKeywordTypeFromText = text => {
  const firstChar = text[0];
  const lastChar = text[text.length - 1];

  if (firstChar === '"' && lastChar === '"') {
    return AdWordsKeywordTypes.PHRASE;
  }

  if (firstChar === '[' && lastChar === ']') {
    return AdWordsKeywordTypes.EXACT;
  }

  return null;
};
export const getRawKeywordFromText = text => {
  const type = getKeywordTypeFromText(text);

  if (!type) {
    return text;
  }

  return text.substr(1, text.length - 2);
};
export const addKeywordTypeToText = (text, type) => {
  const rawText = getRawKeywordFromText(text);

  switch (type) {
    case AdWordsKeywordTypes.PHRASE:
      return `"${rawText}"`;

    case AdWordsKeywordTypes.EXACT:
      return `[${rawText}]`;

    case AdWordsKeywordTypes.BROAD:
    default:
      return rawText;
  }
};